import React, { useState } from 'react';
import api from '../services/api';

const ExcelUpload = () => {
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setMessage('');
        setResult(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            setMessage('Пожалуйста, выберите файл');
            return;
        }

        setLoading(true);
        setMessage('');
        setResult(null);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await api.uploadAccounts(formData);
            
            if (response.data) {
                setResult(response.data);
                if (response.data.success > 0) {
                    setMessage(`Успешно обработано: ${response.data.success} записей`);
                }
                if (response.data.errors > 0) {
                    setMessage(prev => prev + `, Ошибок: ${response.data.errors}`);
                }
            } else {
                setMessage(response.message || 'Файл успешно загружен');
            }
        } catch (error) {
            setMessage('Ошибка загрузки файла');
            console.error('Upload error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page">
            <h2>Загрузка данных из Excel</h2>
            <p>Загрузите Excel файл с данными лицевых счетов</p>
            
            <div className="upload-container">
                <form onSubmit={handleSubmit} className="upload-form">
                    <div className="form-group">
                        <label htmlFor="file">Выберите Excel файл:</label>
                        <input
                            type="file"
                            id="file"
                            accept=".xlsx,.xls"
                            onChange={handleFileChange}
                            required
                        />
                    </div>
                    
                    <button 
                        type="submit" 
                        disabled={loading || !file}
                        className="upload-btn"
                    >
                        {loading ? 'Загрузка...' : 'Загрузить'}
                    </button>
                </form>

                {message && (
                    <div className={`message ${message.includes('Ошибка') ? 'error' : 'success'}`}>
                        {message}
                    </div>
                )}

                {result && (
                    <div className="upload-result">
                        <h4>Результаты обработки:</h4>
                        <div className="result-stats">
                            <div className="stat success">
                                <strong>Успешно:</strong> {result.success}
                            </div>
                            <div className="stat error">
                                <strong>Ошибок:</strong> {result.errors}
                            </div>
                        </div>

                        {result.warnings && result.warnings.length > 0 && (
                            <div className="warnings-section">
                                <h5>Предупреждения и ошибки:</h5>
                                <div className="warnings-list">
                                    {result.warnings.map((warning, index) => (
                                        <div key={index} className="warning-item">
                                            {warning}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}

                <div className="upload-info">
                    <h4>Формат файла:</h4>
                    <ul>
                        <li>Данные начинаются с 4-й строки</li>
                        <li>Столбец G (7) - ФИО владельца (поле name таблицы person)</li>
                        <li>Столбец H (8) - ИНН (поле inn таблицы person)</li>
                        <li>Столбец I (9) - Номер лицевого счета (поле number таблицы account)</li>
                        <li>Столбец J (10) - Город (поле city таблицы address)</li>
                        <li>Столбец K (11) - Улица (поле street таблицы address)</li>
                        <li>Столбец L (12) - Дом (поле home таблицы address)</li>
                        <li>Столбец M (13) - Квартира (поле apartment таблицы address)</li>
                    </ul>
                    
                    <div className="upload-note">
                        <strong>Примечание:</strong> Если лицевой счет уже существует в базе, 
                        он будет пропущен и отмечен как предупреждение.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExcelUpload;